module.exports = __webpack_public_path__ + "static/media/zolePlayed_1000_5000.ee76aab1.png";